import { render } from "./Collapsable.vue?vue&type=template&id=56e62e00"
import script from "./Collapsable.vue?vue&type=script&lang=js"
export * from "./Collapsable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__